import { useSyncExternalStore } from 'react';

const CLE = 'prorata_avenant_config';
const EVT = 'prorata-avenant-config';
const VIDE = '{"desactive":false,"pourcentage":"","jours":""}';
let cache = { raw: null, val: null };
const lire = () => {
  const raw = sessionStorage.getItem(CLE) || VIDE;
  if (raw !== cache.raw) cache = { raw, val: JSON.parse(raw) };
  return cache.val;
};
const abonner = (cb) => { window.addEventListener(EVT, cb); return () => window.removeEventListener(EVT, cb); };

/** Réglage du prorata d'avenant (personnalisation super admin) partagé dans la session. */
export const useProrataConfig = () => {
  const config = useSyncExternalStore(abonner, lire);
  const set = (patch) => { sessionStorage.setItem(CLE, JSON.stringify({ ...lire(), ...patch })); window.dispatchEvent(new Event(EVT)); };
  return [config, set];
};

export const ecrireProrataConfig = (cfg) => {
  sessionStorage.setItem(CLE, JSON.stringify({ ...JSON.parse(VIDE), ...(cfg || {}) }));
  window.dispatchEvent(new Event(EVT));
};

const r2 = (v) => Math.round((Number(v) || 0) * 100) / 100;

// Mois restants jusqu'à la date de fin, le mois entamé compte en entier (1 à 12)
export const moisRestants = (dateFin, aujourdhui = new Date()) => {
  const fin = new Date(dateFin);
  if (Number.isNaN(fin.getTime())) return 12;
  let mois = (fin.getFullYear() - aujourdhui.getFullYear()) * 12 + (fin.getMonth() - aujourdhui.getMonth());
  if (fin.getDate() > aujourdhui.getDate()) mois += 1;
  return Math.min(12, Math.max(1, mois));
};

export const calculerProrata = (config, dateFin) => {
  const mois = moisRestants(dateFin);
  if (config?.desactive) return { facteur: 1, mode: 'desactive', mois };
  const pct = parseFloat(config?.pourcentage);
  if (pct > 0) return { facteur: Math.min(1, pct / 100), mode: 'pourcentage', mois };
  const jours = parseInt(config?.jours, 10);
  if (jours > 0) return { facteur: Math.min(1, jours / 365), mode: 'jours', mois, jours };
  return { facteur: mois / 12, mode: 'mois', mois };
};

export const appliquerProrata = (brut, prorata) => {
  const f = prorata.facteur;
  const taxes = brut.taxes || {};
  return {
    ...brut,
    montant_ht: r2(brut.montant_ht * f),
    montant_ttc: r2(brut.montant_ttc * f),
    taxes: {
      ...taxes,
      ...(Array.isArray(taxes.detail) && { detail: taxes.detail.map((t) => ({ ...t, montant: r2(t.montant * f) })) }),
      ...(taxes.total_taxes != null && { total_taxes: r2(taxes.total_taxes * f) }),
    },
    prorata: { ...prorata, facteur: Math.round(f * 10000) / 10000 },
    ...(brut.plancher_contributif && { plancher_contributif: {
      ...brut.plancher_contributif,
      seuil: r2(brut.plancher_contributif.seuil * f),
      montant_ht_origine: r2(brut.plancher_contributif.montant_ht_origine * f),
      seuil_annuel: brut.plancher_contributif.seuil,
    } }),
    _brut: brut,
  };
};
